import { getComposeStore } from 'owa-calendar-compose-store-manager';
import { orchestrator } from 'satcheljs';
import {
    onAccountChanged,
    onAttachmentsCleared,
    resetFullCompose,
    resetQuickCompose,
} from 'owa-calendar-compose-form-actions';
import type CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';

import {
    FULL_COMPOSE_FORM_TYPE,
    QUICK_COMPOSE_FORM_TYPE,
    FullComposeFormViewType,
    QuickComposeViewType,
} from 'owa-calendar-helpers-types/lib/ComposeTypes';
import { addDays } from 'owa-datetime';
import type { QuickComposeViewState } from 'owa-calendar-compose-types';
import { lazyOperateContent } from 'owa-editor';

export default orchestrator(onAccountChanged, actionMessage => {
    const store = getComposeStore();
    const { event, uiState } = store;

    const initialCalendarEvent = {
        Start: event.Start,
        End: event.End,
        ReminderMinutesBeforeStart: event.ReminderMinutesBeforeStart,
        ParentFolderId: actionMessage.folderId,
        IsAllDayEvent: event.IsAllDayEvent,
    } as CalendarEvent;

    // Remove all attachments from the event and clear off the attachment well (in case of full compose) when account is being changed
    onAttachmentsCleared();

    // Clear the content in the editor
    lazyOperateContent.import().then(operateContent => {
        operateContent(uiState.bodyViewState, editor => {
            editor.setContent('');
            return null;
        });
    });

    if (store.openedForm == FULL_COMPOSE_FORM_TYPE) {
        // account for the friendlyEndDateForAllDay adjustment
        if (initialCalendarEvent.IsAllDayEvent) {
            initialCalendarEvent.End = addDays(initialCalendarEvent.End, 1);
        }

        resetFullCompose(initialCalendarEvent, store.uiState.viewType as FullComposeFormViewType);
    } else if (store.openedForm == QUICK_COMPOSE_FORM_TYPE) {
        resetQuickCompose(
            initialCalendarEvent,
            store.metricsInfo?.quickComposeEntrySource,
            store.uiState.viewType as QuickComposeViewType,
            (store.uiState as QuickComposeViewState).surfaceAnchor
        );
    }
});
